// start:ng42.barrel
import './components';
import './components/billingCycle';
import './components/dashboard';
import './components/invoice';
import './services';
import './tuition-fees.constants';
// end:ng42.barrel